import React from 'react';
import {Button, Input, Layout, Modal, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import './style.scss'

const GroupModal = (props) => {
    const {
        isModalOpen,
        setIsModalOpen,
        // groupName,
        // handleInputChange,
        // handleConfirmClick,
        isNewGroup,
    } = props
    return (
        <Modal
            className={'gp-ml-new-album-modal'}
            visible={isModalOpen}
            onOk={_ => setIsModalOpen(false)}
            onCancel={_ => setIsModalOpen(false)}
        >
            {isNewGroup ?
                <div>
                    <p className={'ml-new-album-modal-title'}>Create a New Group</p>
                </div> : <p className={'ml-new-album-modal-title'}>Rename Your Group</p>}

            <p className={'ml-new-album-modal-sub-title'} style={{
                fontSize:'0.9vw',
                marginTop:'0'
            }}>Give Your Group a Name</p>
            <Input className={'ml-new-album-modal-input'}
                   style={{width:'17vw',margin:'4vh 0 0 5vw',height:'4.6vh'}}
                   placeholder="Group Name"
                   // value={albumName} // Bind input value to state
                   // onChange={handleInputChange} // Set up onChange handler
            />
            <Row justify={'center'} style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems:'center',
                marginTop:'4vh',
            }}>
                <Button className={'h-gp-btn'}
                        onClick={()=>{
                            window.alert('Success!')
                            setIsModalOpen(false)
                        }}
                >
                    Confirm
                </Button>
                <Button className={'h-gp-btn'}
                        style={{marginLeft:'1vw'}}
                        onClick={()=>{
                            setIsModalOpen(false)
                        }}
                >
                    Close
                </Button>
            </Row>

        </Modal>
    )
}

export default GroupModal;
